<template>
  <main class="main">
    <div class="first-section-container">
      <img src="../assets/bg.jpg" class="bg"/>
      <div class="section first-section">
        <div class="wrapper">
          <div class="title">{{ $t(`PAYMENT DETAILS`) }}</div>
          <div class="form">
            <label>
              <span class="title-tiny">{{ $t(`FIRST NAME:`) }}</span>
              <input type="text" v-model="name" :placeholder="$t('Your first name')"/>
            </label>
            <label>
              <span class="title-tiny">{{ $t(`LAST NAME:`) }}</span>
              <input type="text" v-model="surname" :placeholder="$t('Your last name')"/>
            </label>
            <label>
              <span class="title-tiny">{{ $t(`PHONE:`) }}</span>
              <input type="number" v-model="phone" :placeholder="$t('Your phone number')"/>
            </label>
            <label>
              <span class="title-tiny">{{ $t(`EMAIL:`) }}</span>
              <input type="email" v-model="email" :placeholder="$t('Your email')"/>
            </label>
            <label>
              <span class="title-tiny">{{ $t(`ADDRESS:`) }}</span>
              <input type="text" v-model="address" :placeholder="$t('Your address')"/>
            </label>
            <label>
              <span class="title-tiny">{{ $t(`CITY:`) }}</span>
              <input type="text" v-model="city" :placeholder="$t('Your city')"/>
            </label>
            <label>
              <span class="title-tiny">{{ $t(`COUNTRY:`) }}</span>
              <select v-model="country">
                <option value="" disabled selected>{{ $t(`Your county`) }}</option>
                <option v-for="item in countryOptions" :value="item.id" :key="item.title">{{item.title}}</option>
              </select>
            </label>
            <label>
              <span class="title-tiny">{{ $t(`ZIP CODE:`) }}</span>
              <input type="text" v-model="postCode" :placeholder="$t('Your zip code')"/>
            </label>
            <div :class="['button', {'disabled': !requiredFieldsAreFilled}]" @click="submit">{{ $t(`Card`) }}</div>
            <transition name="fade">
              <div class="desc error" v-if="$parent.error">{{$parent.error}}</div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>

export default {
  name: 'Cart',
  props: [],
  components: {
  },
  data: function() {
    return {
      imgDomain: '',
      countryOptions: [],
      name: '',
      surname: '',
      phone: '',
      email: '',
      address: '',
      city: '',
      country: '',
      postCode: ''
    }
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
    this.getProfile();
    this.getCounties();
    if (this.$route.query.amount) {
      this.$emit('setAmount', this.$route.query.amount);
    }
  },
  computed: {
    requiredFieldsAreFilled() {
      let fieldsAreFilled;
      if(
        this.name && this.surname  && this.phone && 
        this.email && this.country && 
        this.city && this.address  
        && this.postCode 
      ) {
        fieldsAreFilled = true;
      } else {
        fieldsAreFilled = false;
      }
      return fieldsAreFilled;
    }
  },
  methods: {
    submit() {
      let amount = this.$parent.amount;
      let data = {
        "first_name": this.name,
        "last_name": this.surname,
        "phone": this.phone,
        "email": this.email,
        "country_id": this.country,
        "city": this.city,
        "address": this.address,
        "zip": this.postCode,
        "amount": amount,
        "currency": this.$parent.currencyCode
      }
      this.$emit('topUp', data)
    },
    getProfile() {
      this.$http.get(process.env.VUE_APP_API + 'user/profile')
      .then((res) => {
          this.name = res.data.name;
          this.surname = res.data.surname;
          this.phone = res.data.phone;
      })
      .catch((res) => {
        if(res.response.status === 401) {
          this.$parent.openSignInModal();
        }
      })
    },
    getCounties() {
      this.$http.get(process.env.VUE_APP_API + 'countries')
      .then((res) => {
          this.countryOptions = res.data.payload;
         
      })
      .catch((res) => {
        if(res.response.status === 401) {
          this.$parent.openSignInModal();
        }
      })
    }
  }
}
</script>